const labels = {
  "roles.player": "Jugador",
  "roles.coach": "Entrenador",
  "roles.parent": "Padre",
  "roles.account_owner": "Propietario de la cuenta",
  "roles.owner": "Propietario",
  "roles.admin": "Administrador",
  "roles.member": "Jugador",
  "roles.analyst": "Analista",
  "roles.guest": "Invitado",
  "roles.demo": "Demo",
};

export const roles = {
  ...labels,
};
